/**
 * Módulo do componente Matricula Termo
 */
(function(){
	angular.module('matriculaTermoModule', []);
})();